<ion-item class="Templates-item" (click)="showFullInfo(item)">
  <ion-label slot=start>{{item.phone}}</ion-label>
  <ion-label class="Templates-item__value" slot="end" class="ion-text-right">{{item.name}}</ion-label>
</ion-item>